import { Routes, Route } from "react-router-dom";
// import Homepage from "../pages/Homepage";
import ManpowerSection from "../pages/Manpower";
import MyPage from "../pages/Mypage";
import CountryWideOperations from "../pages/AboutUs/Countrywide";
import CEOPage from "../pages/AboutUs/Ceo";
// import ContactForm from "../pages/AboutUs/Contect";
import MissionVision from "../pages/AboutUs/Mission&Vision";
import ManagementProfile from "../pages/AboutUs/ManagementProfile";
import FounderMessage from "../pages/AboutUs/FounderMessage";
import LogosGallery from "../pages/AboutUs/MajorClient";
import ToolsAndPlants from "../pages/Resources/Tools&Plants";
import ManPower from "../pages/Resources/ManPower";
import CompletionCertificates from "../pages/Credentials/CompletionCertificates";
import ReadyMixConcrete from "../pages/PacificGroup/ReadyMixConcrete";
import TCCConstruction from "../pages/PacificGroup/Pacificconcrete";
import OfficeLocation from "../pages/ContactUs/Officelocation";
import JobApplicationForm from "../pages/ContactUs/JobApplication";
import PECCertificates from "../pages/Credentials/PECCertificates";
import AffiliationCertificates from "../pages/Credentials/AffiliationCertificates";
import ToolsAndPlantsdetail from "../pages/Resources/ToolsAndPlantsdetail";
import ManPowerList from "../pages/Resources/ManPowerList";
import OrganizationChart from "../pages/AboutUs/Organizationchart";
import TariqBlock from "../pages/Services/Tariq-Block";
import UnionTower from "../pages/Services/UnionTower";
import BahriaOrchard from "../pages/Services/BahriaOrchard";
import BoulevardHeights from "../pages/Services/BoulevardHeights";
import Building23A from "../pages/Services/Building23A";
import Building29 from "../pages/Services/Building29";
import CityCenter from "../pages/Services/CityCenter";
import DarulShifa from "../pages/Services/DarulShifa";
import FiveStar from "../pages/Services/FiveStar";
import FiveStarTextiles from "../pages/Services/FiveStarTextiles";
import IslamicCentre from "../pages/Services/IslamicCentre";
import MAJinnahMosque from "../pages/Services/MAJinnahMosque ";
import MasjidAlHussain from "../pages/Services/MasjidAlHussain ";
import Residentialvillas from "../pages/Services/Residentialvillas";
import SitaraSapna from "../pages/Services/SitaraSapna";
import OurServices from "../pages/OurServices/OurServices";
import AllProjects from "../pages/Projects/AllProject";
import CAPCertificate from "../pages/Credentials/CAPCertificate";
import PRACertificate from "../pages/Credentials/PRACertificate";
import Auratower from "../pages/Services/Auratower";



function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MyPage />} />
      {/* <Route path="/MyPage" element={<MyPage />} /> */}
      {/* <Route path="/" element={<Homepage />} /> */}
      <Route path="/about" element={<ManpowerSection />} />
      <Route path="/country-wide-operations" element={<CountryWideOperations />} />
      <Route path="/ceo" element={<CEOPage />} />
      <Route path="/mission-and-vision" element={<MissionVision />} />
      <Route path="/management-profile" element={<ManagementProfile />} />
      <Route path="/founder-message" element={<FounderMessage />} />
      <Route path="/major-clients" element={<LogosGallery />} />
      <Route path="/all-projects" element={<AllProjects />} />
      {/* <Route path="/project-completed" element={<ProjectsCompleted/>}/> */}


      <Route path="/tariq-block" element={<TariqBlock />} />
      <Route path="/uniont-tower" element={<UnionTower />} />
      <Route path="/boahria-orchard" element={<BahriaOrchard />} />
      <Route path="/boulevard-heights" element={<BoulevardHeights />} />
      <Route path="/building-23A" element={<Building23A />} />
      <Route path="/building-29A" element={<Building29 />} />
      <Route path="/city-center" element={<CityCenter />} />
      <Route path="/dar-ul-shifa" element={<DarulShifa />} />
      <Route path="/five-star" element={<FiveStar />} />
      <Route path="/five-star-textiles" element={<FiveStarTextiles />} />
      <Route path="/islamic-research-centre" element={<IslamicCentre />} />
      <Route path="/m.a-jinnah-mosque" element={<MAJinnahMosque />} />
      <Route path="/masjid-al-hussain" element={<MasjidAlHussain />} />
      <Route path="/residential-villas" element={<Residentialvillas />} />
      <Route path="/sitara-sapna" element={<SitaraSapna />} />
      <Route path="/our-services" element={<OurServices />} />
      <Route path="/auratower" element={<Auratower />} />


      <Route path="/tools-and-plants" element={<ToolsAndPlants />} />
      <Route path="/man-power" element={<ManPower />} />
      <Route path="/completion-certificates" element={<CompletionCertificates />} />
      <Route path="/Pacific-mix-concrete" element={<ReadyMixConcrete />} />
      <Route path="/Pacific-concrete" element={<TCCConstruction />} />
      <Route path="/job-application" element={<JobApplicationForm />} />
      <Route path="/office-location" element={<OfficeLocation />} />
      <Route path="/pec-certificates" element={<PECCertificates />} />
      <Route path="/cap-certificates" element={<CAPCertificate />} />
      <Route path="/pra-certificates" element={<PRACertificate />} />
      <Route path="/affiliation-certificates" element={<AffiliationCertificates />} />
      <Route path="/tools-and-plants-list" element={<ToolsAndPlantsdetail />} />
      <Route path="/man-power-list" element={<ManPowerList />} />
      <Route path="/organizational-chart" element={<OrganizationChart />} />
    </Routes>
  );
}

export default AppRoutes;
